export default __webpack_public_path__ + "static/media/bnr3.546e1b63.jpg";